import React from 'react';
import { Drawer as Draw } from 'antd'

export default function Drawer({footerContent, visible, title, children, setVisible}) {
    const onClose = () => {
        setVisible(false);
    };
    
    return (
        <Draw
            title={title}
            placement="right"
            closable={true}
            onClose={onClose}
            open={visible}
            footer={footerContent}
        >
            {children}
        </Draw>
    )
}